import "./SubMenuNavItem.less";
import * as React from "react";
import { AtTooltip } from "@atman/design-system";
import { NavLink as BootstrapNavLink, NavItem, NavItemProps } from "reactstrap";
import { Default, Mobile } from "../../BaseResponsiveComponent";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { NavLink, Route } from "react-router-dom";
import { UrlFormatter } from "@atman/business";

export interface ISubMenuNavItemProps extends NavItemProps {
    href: string;
    uniqueKey: string;
    label: string;
    icon?: IconProp;
    iconProps?: Partial<Omit<FontAwesomeIconProps, "icon">>;
    disabled?: boolean;
}

export const SubMenuNavItem: React.FC<ISubMenuNavItemProps> = (props) => {
    const { href, icon, uniqueKey, disabled, onClick, className, iconProps, label, ...navItemProps } = props;

    let elementClassName = "SubMenuNavItem";

    if (className) {
        elementClassName += ` ${className}`;
    }

    if (disabled) {
        elementClassName += ` disabled`;
    }

    const containerId = `sub-menu-icon-container-${uniqueKey}`;
    const navItemContent = (
        <>
            {icon && (
                <span className="icon-container">
                    <FontAwesomeIcon icon={icon} {...iconProps} />
                </span>
            )}
            <Default>
                <div className="nav-item-label">{label}</div>
            </Default>
            <Mobile>
                <AtTooltip
                    className="sidebar-tooltip"
                    placement="right"
                    modifiers={{ preventOverflow: { enabled: true, boundariesElement: "viewport" } }}
                    delay={{ show: 100, hide: 0 }}
                    target={containerId}
                >
                    {label}
                </AtTooltip>
            </Mobile>
        </>
    );

    if (!href) {
        return (
            <NavItem className={elementClassName} {...navItemProps} id={containerId}>
                <BootstrapNavLink onClick={onClick}>{navItemContent}</BootstrapNavLink>
            </NavItem>
        );
    }

    const inAppHref = UrlFormatter.formatReactPath(href);

    return (
        <Route path={inAppHref}>
            {({ match }) => (
                <NavItem className={elementClassName} active={!!match} {...navItemProps}>
                    <NavLink to={inAppHref} id={containerId}>
                        {navItemContent}
                    </NavLink>
                </NavItem>
            )}
        </Route>
    );
};
